module.exports = __webpack_public_path__ + "static/media/googleWallet.96a3c4e5.ico";